























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { looksModule, clientsModule } from '@/store';
import Upload from '@/components/common/Upload.vue';
import VImage from '@/components/common/VImage.vue';

@Component({
  name: 'add-look',
  components: {
    Upload,
    VImage,
  },
})
export default class Clients extends Vue {
  @Prop({ type: String, default: 'REAL' }) status!: 'REAL' | 'SANDBOX';

  creating = false;

  form : {
    category: null | number,
    name: '',
  } = {
    category: null,
    name: '',
  }

  get client() {
    return clientsModule.model;
  }

  get categories() {
    return looksModule.categories;
  }

  onSubmit() {
    (this.$refs.form as Form).validate((valid) => {
      if (valid && this.client && this.client.id && this.form.category) {
        looksModule.saveLook({
          look: {
            category: this.form.category,
            name: this.form.name,
          },
          userId: this.client.id,
          status: this.status,
        });
        this.form.category = null;
        this.form.name = '';
        this.creating = false;
        return false;
      }
      // console.error('error submit!!');
      return false;
    });
  }
}
